const comments = [
  {
    avatar: '吃瓜群众',
    name: '八卦小能手',
    time: '2小时前',
    content: '这个瓜我吃了！作为老粉真的没想到会这样，只能说娱乐圈的水太深了，表面光鲜亮丽背后全是故事。91黑料网的爆料速度真的快，全网第一个发的就是这里。',
    likes: '3.2k',
  },
  {
    avatar: '资深瓜友',
    name: '深夜吃瓜人',
    time: '5小时前',
    content: '一直在91黑料网追更，每天必刷。这次的爆料太劲爆了，看完直接睡不着。希望平台能继续深挖，给我们带来更多真实可靠的黑料内容。支持91黑料网！',
    likes: '2.8k',
  },
  {
    avatar: '铁杆粉丝',
    name: '瓜田守望者',
    time: '8小时前',
    content: '从2020年就开始用91黑料网了，见证了这个平台一步步成长。现在的爆料质量和更新速度都比以前好太多了，绝对是吃瓜第一选择。推荐给所有爱吃瓜的朋友！',
    likes: '1.9k',
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="w-full py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
            网友热评
          </h2>
          <p className="mt-3 text-sm text-foreground-500 max-w-lg mx-auto">
            来自吃瓜群众的真实声音，看看大家都在聊什么
          </p>
        </div>

        <div className="max-w-3xl mx-auto space-y-4">
          {comments.map((comment) => (
            <div
              key={comment.name}
              className="p-5 md:p-6 rounded-xl bg-background-100 border border-background-200/70"
            >
              <div className="flex items-center gap-3 mb-3">
                <div className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-100 text-primary-600 text-sm font-label font-bold flex-shrink-0">
                  {comment.avatar.slice(0, 1)}
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2 flex-wrap">
                    <span className="font-label text-sm font-semibold text-foreground-900 whitespace-nowrap">
                      {comment.name}
                    </span>
                    <span className="text-xs text-foreground-400 whitespace-nowrap">{comment.time}</span>
                  </div>
                </div>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed">
                {comment.content}
              </p>
              <div className="mt-3 flex items-center gap-4">
                <button className="flex items-center gap-1.5 text-xs text-foreground-400 hover:text-primary-500 transition-colors cursor-pointer whitespace-nowrap">
                  <i className="ri-thumb-up-line"></i>
                  <span>{comment.likes}</span>
                </button>
                <button className="flex items-center gap-1.5 text-xs text-foreground-400 hover:text-primary-500 transition-colors cursor-pointer whitespace-nowrap">
                  <i className="ri-chat-1-line"></i>
                  <span>回复</span>
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}